<script lang="ts">
  import {TopnavEvents} from '@/utils/top-nav-next-custom-events';
  import loadingStore from '@/pages/preview/loading-store';
  import {downloadDialog, thumbDraft, user} from '@/store';
  import {canAccess} from '@/utils/common';
  import {Features} from '@/types/common';

  export let saveNewProject = async () => false;

  // currently disabled
  let isStep4DownloadClicked = false;

  let showDropdown = false;
  let isDisabled = true;

  const closeDropDown = (event: Event) => (showDropdown = false);

  $: {
    isDisabled = $loadingStore;
    (showDropdown && setTimeout(() => window.addEventListener('click', closeDropDown))) ||
      window.removeEventListener('click', closeDropDown);
  }

  const options = [
    {
      title: 'PNG',
      description: 'Best Image Quality. Retains Transparency',
      isRecommended: true,
      isShare: false,
      icon: '',
      action: async () => {
        if (!$thumbDraft.isProject) saveNewProject();
        window.dispatchEvent(
          new CustomEvent(TopnavEvents.download, {detail: {qualityPreset: 'default', fileType: 'png'}})
        );
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    },
    {
      title: 'JPG',
      description: 'Smaller file size. Best for web graphics. Transparency not retained',
      isRecommended: false,
      isShare: false,
      icon: '',
      action: async () => {
        if (!$thumbDraft.isProject) await saveNewProject();
        window.dispatchEvent(
          new CustomEvent(TopnavEvents.download, {detail: {qualityPreset: 'default', fileType: 'jpeg'}})
        );
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    },
    {
      title: 'Export to Sermon Send',
      description: 'Add to Sermon Send library',
      isRecommended: false,
      isShare: true,
      icon: 'https://storage.googleapis.com/sermonshots-local-storage/images/sermonsend.png',
      action: async () => {
        if (!$thumbDraft.isProject) await saveNewProject();
        window.dispatchEvent(
          new CustomEvent(TopnavEvents.download, {
            detail: {qualityPreset: 'default', fileType: 'png', isSermonSend: true}
          })
        );
        showDropdown = false;
        isStep4DownloadClicked = true;
      }
    }
  ];
</script>

<div class="h-full w-full">
  {#if isStep4DownloadClicked && false}
    <!-- DISABLED FOR NOW -->
    <div class="flex h-full w-full">
      <button
        on:click={() => downloadDialog.set(true)}
        class="flex w-full items-center gap-2 rounded-lg border border-rose-500 bg-rose-500 px-4 py-2 text-zinc-100 transition-all hover:bg-rose-600"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-download"></i>
        Download
      </button>
    </div>
  {:else}
    <div
      class="flex h-full w-full gap-2 rounded-lg bg-gradient-to-r from-primary to-secondary px-4 py-2 text-white {isDisabled
        ? 'cursor-not-allowed'
        : 'cursor-pointer'}"
    >
      <button
        on:click={() => options[0].action()}
        class="flex w-full items-center justify-center gap-2 transition-all {isDisabled
          ? 'cursor-not-allowed'
          : 'cursor-pointer'}"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-download"></i>
        Download
      </button>
      <button
        on:click={() => (showDropdown = !showDropdown)}
        class="transition-all {isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}"
        disabled={isDisabled}
      >
        <i class="fa-solid fa-chevron-down"></i>
      </button>
    </div>
    <div
      class="absolute right-0 z-10 mt-1 grid w-[20rem] overflow-hidden rounded-lg rounded-bl-lg bg-white p-2 {showDropdown ===
      true
        ? ''
        : 'hidden'} text-gray-700"
      style="z-index: 99;"
    >
      {#each options as option, i}
        {#if option.isShare}
          <p class="px-4 pt-2 text-xs font-bold text-secondary-200">Send To</p>
        {/if}
        <button
          on:click={option.action}
          class="grid rounded-lg p-4 transition-all hover:bg-gray-100"
          disabled={isDisabled}
        >
          <div class="flex items-center gap-1">
            <span class="font-medium">{option.title}</span>
            {#if option.icon !== ''}
              <span class="ml-auto">
                <img src={option.icon} class="grayscale" alt="sermon-send" width="20" height="20" />
              </span>
            {/if}
            <span
              class="ml-auto rounded bg-orange-100 px-2 py-1 text-xs font-bold text-secondary-200 {option.isRecommended
                ? ''
                : 'hidden'}">Recommended</span
            >
          </div>
          <p class="pt-1 text-start text-xs font-light">{option.description}</p>
        </button>
      {/each}
    </div>
  {/if}
</div>
